import { Component } from 'react';
import { translate } from 'react-i18next';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';

// Components
import CustomModal from 'components/CustomModal';
import { MultiSelectFieldWithTicks, InputTextArea, CheckBoxField } from 'components/Fields';

// Constants && helpers
import { examinationSimpleList, sidesList } from './constants';
import { parseSidesToValue, checkSidesGroupeError, validate } from './helpers';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

class SendToRadiologyModal extends Component {
  constructor() {
    super();
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.renderSides = this.renderSides.bind(this);
  }

  renderSides(input) {
    const { i18n } = this.props;
    const { fields, meta } = input;
    return fields.map((side, i) => {
      return (
        <Field
          {...meta}
          key={side}
          component={CheckBoxField}
          name={side}
          rightLabel={sidesList[i] && i18n.t(sidesList[i].label)}
        />
      );
    });
  }

  onFormSubmit(paperPrescription) {
    const {
      onSubmit,
      sendToRadiologyForm: { values },
      reset
    } = this.props;

    const sendResult = { ...values };
    if (sendResult.sides) {
      sendResult.sides = parseSidesToValue(sidesList, values.sides);
    }

    if (onSubmit) {
      onSubmit(sendResult, paperPrescription);
      reset();
    }
  }

  onCloseClick() {
    const { reset, closeModal } = this.props;
    closeModal();
    reset();
  }

  render() {
    const { isOpen, i18n, invalid, pristine, sendToRadiologyForm } = this.props;
    const sidesGroupeError = checkSidesGroupeError(sendToRadiologyForm);

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={this.onCloseClick}
        style={{ content: { maxWidth: '33em', padding: 0 } }}
      >
        <modalStyles.CommonModalWrapper>
          {/* ──── Header ───────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection className="header-wrapper">
            <modalStyles.ModalCloseIcon className="close-icon" onClick={this.onCloseClick} />
            <modalStyles.ModalTitle>{i18n.t('modal_to_radiology_title')}</modalStyles.ModalTitle>
          </modalStyles.ModalBlockSection>

          {/* ──── Content ──────────────────────────────────────────────────────────────────── */}
          <form>
            {/* Examination */}
            <modalStyles.ModalBlockSection borderBottom>
              <Field
                component={MultiSelectFieldWithTicks}
                data={examinationSimpleList}
                name="examinations"
                label={i18n.t('modal_to_radiology_type_examination_title')}
              />
            </modalStyles.ModalBlockSection>

            {/* Sides */}
            {sidesList && (
              <modalStyles.ModalBlockSection
                className={`sides ${sidesGroupeError ? 'show-group-error' : ''}`}
                borderBottom
              >
                <p>{i18n.t('modal_to_radiology_side_title')}</p>
                <FieldArray name="sides" component={this.renderSides} />

                {sidesGroupeError && (
                  <span className="error-groupe-message">{i18n.t(sidesGroupeError)}</span>
                )}
              </modalStyles.ModalBlockSection>
            )}

            {/* Clinical information */}
            <modalStyles.ModalBlockSection borderBottom className="optional">
              <Field
                component={InputTextArea}
                name="clinicalInformation"
                label={i18n.t('modal_to_radiology_clinical_title')}
                placeholder={i18n.t('modal_to_radiology_clinical_placeholder')}
                optional
              />
            </modalStyles.ModalBlockSection>

            {/* Radiology imaging */}
            <modalStyles.ModalBlockSection borderBottom className="optional">
              <Field
                component={InputTextArea}
                name="radiologyImaging"
                label={i18n.t('modal_to_radiology_imaging_title')}
                placeholder={i18n.t('modal_to_radiology_imaging_placeholder')}
                optional
              />
            </modalStyles.ModalBlockSection>
          </form>

          {/* ──── Footer ────────────────────────────────────────────────────────────────────── */}

          <modalStyles.ModalFooter className="footer">
            <modalStyles.ModalFooterCancelBtn onClick={this.onCloseClick}>
              {i18n.t('popup_cancel_button')}
            </modalStyles.ModalFooterCancelBtn>

            <modalStyles.ModalFooterBtn bgTransparent onClick={this.onFormSubmit}>
              {i18n.t('modal_to_radiology_paper_prescription_btn')}
            </modalStyles.ModalFooterBtn>

            <modalStyles.ModalFooterBtn disabled={invalid || pristine} onClick={this.onFormSubmit}>
              {i18n.t('modal_to_radiology_confirm_btn')}
            </modalStyles.ModalFooterBtn>
          </modalStyles.ModalFooter>
        </modalStyles.CommonModalWrapper>
      </CustomModal>
    );
  }
}

const mapStateToProps = state => ({
  sendToRadiologyForm: state && state.form && state.form.sendToRadiologyForm
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'sendToRadiologyForm',
    validate,
    initialValues: {
      sides: sidesList.map(() => false)
    }
  })(translate()(SendToRadiologyModal))
);
